import React from 'react';
import {Box, Grid} from '@mui/material';
import {Panel} from '../../components/Panel/Panel';
import {themeColors} from '../../theme/Theme';
import {RichEditor} from '../../components/RichEditor/RichEditor';
import AutoField, {ActionType} from '../../components/AutoForm/AutoFieldNew';
import {ReportPackTemplateTypes} from '../../schema-types/globalTypes';
import {getReportPackLetterTitle} from './ReportPackHelpers';

interface ReportPackEditorProps {
  templateType?: ReportPackTemplateTypes;
  reportHTML?: string;
  onSave: (val: string) => Promise<any>;
}

export const ReportPackEditor: React.FC<ReportPackEditorProps> = ({
  templateType,
  reportHTML,
  onSave,
}) => {
  //   const [debugFormState, setDebugFormState] = React.useState(reportHTML);
  if (templateType !== ReportPackTemplateTypes.ATTACHMENT_LETTER) {
    return (
      <Box mb={4}>
        <Panel
          title={getReportPackLetterTitle(templateType)}
          color={themeColors.amber}
          style={{
            display: 'flex',
            flexGrow: 1,
          }}
          childrenContainerStyle={{
            display: 'flex',
            flexGrow: 1,
            flexDirection: 'column',
            width: '100%',
            paddingBottom: '0', // Reduce bottom padding in Panel
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12} pb={2}>
              <RichEditor
                formikId="templateHtml"
                placeholder="Edit the report content"
                onSave={(...args) => {
                  //   setDebugFormState(args[0]);
                  return onSave(...args);
                }}
                charLimit={5000}
                initialValue={reportHTML || ''}
              />
              <AutoField
                field={{
                  id: 'noSignatureRequired',
                  disabled: true,
                  initialValue: true,
                  label: 'No signature required',
                  type: ActionType.checkboxToggle,
                  boldLabel: true,
                  fullWidth: true,
                }}
              />
            </Grid>
          </Grid>
        </Panel>
        {/* <ShowIfDebugWrapper>
          Internal form state: <pre>{debugFormState}</pre>
        </ShowIfDebugWrapper> */}
      </Box>
    );
  }
  return null;
};
